import { Mixpanel } from '../services/Mixpanel';
import { ChevronRightIcon } from '@heroicons/react/24/outline';
import PremiumOfferCta from './PremiumOfferCta';
import { usePremiumOffer } from '../contexts/premiumOffer';

export const UpgradeMessage = ({
  featureName = 'feature',
  twoLines = false,
  linkOnly = false,
  size = 'text-sm',
  linkText = 'See premium plans',
}) => {
  const { isOffered } = usePremiumOffer();
  // The offer replaces the plans link outright rather than sitting beside it: it carries its
  // own "See Plans" link, so keeping both would show the plans link twice.
  const linkElement = isOffered ? (
    <PremiumOfferCta
      variant='stacked'
      location='Upgrade Message'
      planLabel={linkText}
      className={twoLines || linkOnly ? '' : 'ml-1 inline-flex'}
    />
  ) : (
    <a
      data-allow-click-when-logged-out
      data-allow-click-when-free-user
      data-allow-click-when-not-owner
      href='https://web.diffit.me/plans'
      target='_blank'
      onClick={() => {
        Mixpanel.track('See plans clicked', {
          location: 'Upgrade Message',
          feature: featureName,
        });
      }}
      className={`${size} font-semibold text-amber-700 hover:text-amber-600 ${
        twoLines || linkOnly ? 'flex items-center gap-1' : 'ml-1'
      }`}>
      {linkText} <ChevronRightIcon className='h-4 w-4 inline' />
    </a>
  );

  if (twoLines) {
    return (
      <div>
        <p className='text-sm text-amber-700'>This {featureName} requires premium access.</p>
        {linkElement}
      </div>
    );
  }

  if (linkOnly) {
    return linkElement;
  }

  return (
    <div>
      <p className='text-sm text-amber-700'>
        This {featureName} requires premium access.
        {linkElement}
      </p>
    </div>
  );
};
